import {
  formatDateTimeLong,
  formatDateTimeShort,
} from "app/containers/Jobs/utils/dateFormat";

// The rule trails a timestamp ("· 1 day before inspection"), so these are
// shorter than the Sending Rules copy in EmailAutomation/EditTemplate.
const RULE_CONTEXT = {
  time_before: "before inspection",
  time_after: "after inspection",
};

const RULE_CONTEXT_BY_EVENT = {
  follow_up: "after report delivery",
};

const READY_COPY_BY_EVENT = {
  report_delivery: "The report is compiled and ready for delivery.",
};

const CANCELED_COPY =
  "This email was not sent for this job. Send manually via your mailbox if needed.";

// Built here rather than taken from the template API's trigger_display, which
// renders "1 days before".
const formatOffset = (value, unit) => {
  const singular = unit.replace(/s$/, "");
  return `${value} ${Number(value) === 1 ? singular : `${singular}s`}`;
};

/**
 * "1 day before inspection", or null when the template has no time offset
 * (manual / immediate triggers, or no template at all).
 */
const describeTriggerRule = (trigger, eventType) => {
  const context =
    RULE_CONTEXT_BY_EVENT[eventType] || RULE_CONTEXT[trigger?.type];
  if (!context || trigger?.value == null || !trigger.unit) return null;
  return `${formatOffset(trigger.value, trigger.unit)} ${context}`;
};

// A pending step has no sent_at, so its timestamp is scheduled_send_at.
const pendingText = ({ timestamp, trigger, eventType }) => {
  const when = formatDateTimeShort(timestamp);
  const rule = describeTriggerRule(trigger, eventType);
  if (when && rule) return `Will send on ${when} · ${rule}`;
  if (when) return `Will send on ${when}`;
  return rule;
};

const metaText = (step) => {
  switch (step.status) {
    case "pending":
      return pendingText(step);
    case "canceled":
      return CANCELED_COPY;
    default:
      return step.description || formatDateTimeLong(step.timestamp);
  }
};

/**
 * The helper text beside an Email Automation row's status badge, as
 * { text, tone } where tone is "muted" or "warn"; null when there is nothing
 * to show.
 */
export const emailRowMeta = (step) => {
  if (step.status === "ready_to_send") {
    const readyCopy = READY_COPY_BY_EVENT[step.eventType];
    // Send Now on this page is still a placeholder, so a ready row with no
    // copy of its own warns that nothing has reached the client.
    return readyCopy
      ? { text: readyCopy, tone: "muted" }
      : { text: "Not emailed yet", tone: "warn" };
  }
  const text = metaText(step);
  return text ? { text, tone: "muted" } : null;
};
